import { ReactElement } from "react";
import { Card, Flex, Text, Link } from "@jsq/ds/core";
import { QuickLinkType } from "../types";
import {
  quickLinksTitle,
  quickLinksContent,
  quickLinksRow,
  quickLinkAnchor,
} from "./styles_vanilla.css";
import { WorkspaceLink } from "./WorkspaceLink";

interface QuickLinksCardProps {
  quickLinksData: QuickLinkType[];
  arenaId?: number | null;
}

export const QuickLinksCard = ({
  quickLinksData,
  arenaId,
}: QuickLinksCardProps): ReactElement => {
  return (
    <Card data-testid="quick-links-card">
      <Text variant="h3" className={quickLinksTitle}>
        Quick links
      </Text>
      <Flex className={quickLinksContent}>
        {typeof arenaId === "number" && (
          <Flex className={quickLinksRow} data-testid="arena-workspace-link-container">
            <WorkspaceLink arenaId={arenaId} />
          </Flex>
        )}

        {quickLinksData.map((link, index) => (
          <Flex key={index} className={quickLinksRow} data-testid={`quick-link-${index}`}>
            <Text>{link.name || ""}</Text>
            <Link
              href={link.url || "#"}
              className={quickLinkAnchor}
              variant="primary"
              icon="external-link"
              shouldOpenInNewTab={true}
              iconPosition={"right"}
            >
              View
            </Link>
          </Flex>
        ))}
      </Flex>
    </Card>
  );
};
